module.exports = __webpack_public_path__ + "static/media/jessica.51691bb1.jpg";